import { render } from "./AppTab.vue?vue&type=template&id=6e0450b9&scoped=true"
import script from "./AppTab.vue?vue&type=script&lang=js"
export * from "./AppTab.vue?vue&type=script&lang=js"

import "./AppTab.vue?vue&type=style&index=0&id=6e0450b9&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0450b9"]])

export default __exports__